const styles = {
    wrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      height: "90vh", // 90% of the viewport height
      padding: "2vh 0",
      backgroundColor: "#f7f9fc", // Light background color
    },
    formContainer: {
      flex: 1, 
      textAlign: "center",
      backgroundColor: "inherit",
      padding: "1rem",
      borderRadius: "8px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Subtle shadow
      maxWidth: "600px", // Limit form width
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "50px",
      boxSizing: "border-box",
    },
    loadingView: {
      textAlign: "center",
      color: "#007bff",
    },
    startJourneyHeading: {
      fontSize: "2em", // Larger text
      fontWeight: "700", // Bold for emphasis
      color: "#2c3e50", // Darker shade for contrast
      textAlign: "center",
      marginBottom: "15px",
      textTransform: "uppercase", // Makes it more commanding
      letterSpacing: "1px", // Improves readability
      position: "relative", // Enables additional styling effects
    },
    input: {
      width: "90%",
      margin: "8px 0",
      border: "1px solid #ddd",
      fontSize: "0.9rem",
      marginBottom: "10px",
      padding: "8px",
      borderRadius: "5px",
    },
    button: {
      width: "90%",
      padding: "8px",
      backgroundColor: "#007bff",
      color: "#fff",
      fontSize: "0.9rem",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background-color 0.3s",
    },
    buttonDisabled: {
      backgroundColor: "#a9d4ff",
      cursor: "not-allowed",
    },
    message: {
      marginTop: "1rem",
      fontSize: "0.9rem",
      fontWeight: "bold",
    },
    quoteContainer: {
      flex: 1, 
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      maxWidth: "80%",
      backgroundColor: "inherit",
      marginBottom: "10px",
    },
    quote: {
      fontSize: "22px",
      fontStyle: "italic",
      color: "#555",
    },
    blurbContainer: {
      flex: 1,
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      maxWidth: "650px",  // Matches maxWidth of formContainer
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "10px",
      boxSizing: "border-box",
    },

    howItWorksContainer: {
      flex: 1,
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      maxWidth: "600px",  // Matches maxWidth of formContainer
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "10px",
      boxSizing: "border-box",
    },
    howItWorksImage: {
      width: "100%",  // Ensures image matches login box width
      height: "auto",
      borderRadius: "5px",
      // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      marginBottom: "10px", // Adds space before the bottom of the screen
      // Responsive design
    },
    privacyLink: {
      border: "none", 
      background: "none", 
      color: "#3498db", 
      cursor: "pointer",
      fontSize: "18px", // Increased font size
      fontWeight: "bold",
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline",
      },
    },
  };
  
  export default styles;